import { format } from 'date-fns'
import { APIFilters, UIFilters } from './types'

type Entries<T> = {
  [K in keyof T]-?: [K, T[K]]
}[keyof T][]
const entries = <T extends object>(obj: T): Entries<T> => Object.entries(obj) as Entries<T>

export const createURLSeachParamsFromAPIFilters = (filters: APIFilters): URLSearchParams => {
  const urlParams = new URLSearchParams()
  entries(filters).map((entries) => {
    const [k, v] = entries
    if (v === undefined) {
      return
    }
    if (Array.isArray(v)) {
      v.forEach((item) => {
        urlParams.append(k, item)
      })
    } else {
      urlParams.set(k, v.toString())
    }
  })
  return urlParams
}

export const createAPIFiltersFromUIFilters = (filters: UIFilters): APIFilters => {
  const apiFilters: APIFilters = {}
  entries(apiFilterExtractor).map(([k, fn]) => {
    const value = fn(filters)
    // @ts-expect-error the apiFilterExtractor is typed as a mapped APIFilters, but I can't get typescript to understand that
    apiFilters[k] = value
  })
  return apiFilters
}

type APIFilterConverter = {
  [TKey in keyof APIFilters]-?: (f: UIFilters) => APIFilters[TKey]
}

const apiFilterExtractor: APIFilterConverter = {
  schoolType: (f) => f.schoolType,
  religiousAffiliation: (f) => f.religiousAffiliation,
  virtual: (f) => f.virtual,
  isActive: (f) => f.isActive,
  title1Program: (f) => f.title1Program,
  isTitle1Eligible: (f) => f.isTitle1Eligible,
  endDate: (f) => formattedDate(f.visitRange?.endDate),
  startDate: (f) => formattedDate(f.visitRange?.startDate),
  minSize: (f) => f.classSize?.min,
  maxSize: (f) => f.classSize?.max,
  pctFreeReducedLunchMin: (f) => f.pctFreeReducedLunch?.min,
  pctFreeReducedLunchMax: (f) => f.pctFreeReducedLunch?.max,
  locations: (f) => f.locations,
  text: (f) => f.text,
}

const formattedDate = (d: Date | undefined) => (d ? format(d, 'yyyy-MM-dd') : undefined)
